import React from 'react'

const OperationContext = React.createContext(null)

export const Provider = OperationContext.Provider
export const Consumer = OperationContext.Consumer

export default OperationContext
